<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 180.539 181.02"
  >
    <g id="Group_1519" transform="translate(-104.461 -330.98)">
      <ellipse
        id="Ellipse_1"
        cx="59.255"
        cy="59.5"
        rx="59.255"
        ry="59.5"
        transform="matrix(1, -0.017, 0.017, 1, 104.461, 333.048)"
        fill="var(--color-background-complement)"
      />
      <g
        id="Ellipse_2"
        transform="translate(113 341)"
        fill="none"
        stroke="var(--color-background-complement)"
        stroke-width="20"
      >
        <ellipse cx="86" cy="85.5" rx="86" ry="85.5" stroke="none" />
        <ellipse cx="86" cy="85.5" rx="76" ry="75.5" fill="none" />
      </g>
    </g>
  </svg>
</template>
